module.exports = __webpack_public_path__ + "static/media/focus-productivity-procrastination.8cb943c7.png";